import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface SavePromptFormProps {
  defaultValue: string;
  chatMode: string;
  onSave: (text: string, chatMode: string) => Promise<void>;
  onCancel: () => void;
}

export const SavePromptForm = ({
  defaultValue,
  chatMode,
  onSave,
  onCancel,
}: SavePromptFormProps) => {
  const [text, setText] = useState(defaultValue);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    const trimmed = text.trim();
    if (!trimmed) {
      return;
    }

    setIsSaving(true);
    try {
      await onSave(trimmed, chatMode);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className='space-y-3 w-80 p-4'>
      <div className='space-y-2'>
        <Label htmlFor='prompt-text' className='text-sm font-medium'>
          Prompt Text
        </Label>
        <Textarea
          id='prompt-text'
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={3}
          placeholder='Enter the prompt text...'
        />
      </div>

      <div className='flex justify-end gap-2 pt-2'>
        <Button variant='outline' size='sm' onClick={onCancel}>
          Cancel
        </Button>
        <Button
          size='sm'
          onClick={handleSave}
          disabled={!text.trim() || isSaving}
        >
          {isSaving ? (
            <>
              <Loader2 className='h-4 w-4 animate-spin mr-1' />
              Saving...
            </>
          ) : (
            'Save'
          )}
        </Button>
      </div>
    </div>
  );
};
